module.exports = __webpack_public_path__ + "0c3865c0549bfa04a8a5df17d1cbca27.ogg";